import { apiRequest } from "../utils/config/apiRequest"
import { apiUrl } from "../utils/endPoints/apiUrl"

export const fetchFeedback = async(query = {})=>{
    try{

        const response = await apiRequest({
            endUrl : apiUrl.feedback.listing,
            method : 'GET',
            query
        })  
        if(response.status === true){
            return{
                 success : true,
                 data : response?.data,
            }
        }else{
            throw new Error(response.message || 'Failed');
        }

    }catch(error){
        console.log("Error", error);
        return{success : true, error : error.message}
    }
}